
import { z } from "zod";

export const AuthStrategyValues = ["phone_code", "password", "reset_password_email_code", "ticket"] as const;
export const AuthStrategySchema = /* @__PURE__ */ z.enum(AuthStrategyValues);
export const AuthStrategy: (typeof AuthStrategySchema)["enum"] = { "phone_code": "phone_code", "password": "password", "reset_password_email_code": "reset_password_email_code", "ticket": "ticket" };
export type AuthStrategy = (typeof AuthStrategyValues)[number];
